import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApplicationRoutingModule } from './application-routing.module';
import { MatListModule, MatTableModule, MatPaginatorModule, MatSortModule, MatTooltipModule, MatAutocompleteModule, MatNativeDateModule, MatInputModule, DateAdapter, MAT_DATE_FORMATS, MatRadioModule, MatBadgeModule } from '@angular/material';

import { StudentDetailsComponent } from './student-details/student-details.component';
import { VisaOhscComponent } from './visa-ohsc/visa-ohsc.component';
import { OnlineAppMenuComponent } from './online-app-menu/online-app-menu.component';
import { ApplicationComponent } from './application.component';
import { ApplicationEditComponent } from './application-edit/application-edit.component';
import { SidebarNavComponent } from './sidebar-nav/sidebar-nav.component';
import { EnglishProficiencyComponent } from './english-proficiency/english-proficiency.component';

import { ApplicationReducer } from './state/application.reducer';
import { DashboardComponent } from '../application/dashboard/dashboard.component';
import { StudentValidationComponent } from './student-validation/student-validation.component';
import { ParentsValidationComponent } from './parents-validation/parents-validation.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ImportantInformationComponent } from './important-information/important-information.component';
import { StudentsParentsValidationComponent } from './students-parents-validation/students-parents-validation.component';
import { AuthGuard } from '../shared/services/auth.guard.service';
import { AuthResolverService } from '../shared/services/auth.resolver.service';
import { ParentGuardianDetailsComponent } from './parent-guardian-details/parent-guardian-details.component';
import { SchoolProgramPlacementComponent } from './school-program-placement/school-program-placement.component';
import { AccommodationWelfareComponent } from './accommodation-welfare/accommodation-welfare.component';
import { SpecialCircumstancesComponent } from './special-circumstances/special-circumstances.component';
import { DefaultCorrespondentComponent } from './default-correspondent/default-correspondent.component';
import { SupportingDocumentsComponent } from './supporting-documents/supporting-documents.component';
import { SummaryComponent } from './summary/summary.component';
import {
  ParentGuardianDetailsEditComponent
} from './parent-guardian-details/parent-guardian-details-edit/parent-guardian-details-edit.component';
import { AddressComponent } from './shared/address/address.component';
import { SharedModule } from '../shared/shared.module';
import { PersonDetailsComponent } from './shared/person-details/person-details.component';
import { PhoneNumberComponent } from './shared/phone-number/phone-number.component';
import { ApplicationDetailsComponent } from './application-details/application-details.component';
import { ApplicationPaymentComponent } from './application-payment/application-payment.component';
import { FileUploadModule } from 'ng2-file-upload';
import { AgentDashboardComponent } from './agent-dashboard/agent-dashboard.component';
import { AgentStudentRegistrationComponent } from './agent-student-registration/agent-student-registration.component';
import { AgentStudentRegistrationGdprComponent } from './agent-student-registration-gdpr/agent-student-registration-gdpr.component';
import { AustralianAddressPipe } from './pipes/australianAddress.pipe';
import { OverseasAddressPipe } from './pipes/overseasAddress.pipe';
import { ClickStopPropagation } from '../directives/click-stop-propagation.directive';
import { UtcDatePipe } from './pipes/utcDate.pipe';
import { ParentLegalcustodianEditComponent } from './parent-guardian-details/parent-legalcustodian-edit/parent-legalcustodian-edit.component';
import { ParentLegalcustodianInfoComponent } from './parent-guardian-details/parent-legalcustodian-edit/parent-legalcustodian-info/parent-legalcustodian-info.component';
import { ParentLegalcustodianDetailsComponent } from './parent-guardian-details/parent-legalcustodian-edit/parent-legalcustodian-details/parent-legalcustodian-details.component';
import { ParentAddressComponent } from './shared/parent-address/parent-address.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DebounceClickModule } from '../shared/directive/appDebounceClick.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { PickDateAdapter, PICK_FORMATS } from './shared/utils/PickDateAdapter';
import { ApplicationAgentDetailsComponent } from './application-agent-details/application-agent-details.component';
import { SummaryPrintComponent } from './summary/summary-print/summary-print.component';
import { DescriptionFromLookupPipe } from './pipes/descriptionFromLookup.pipe';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ApplicationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,

    /*Angular Material Design modules*/
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatBadgeModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    DebounceClickModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    StoreModule.forFeature('application', ApplicationReducer)
  ],
  declarations: [
    ApplicationComponent,
    StudentDetailsComponent,
    VisaOhscComponent,
    OnlineAppMenuComponent,
    ApplicationEditComponent,
    SidebarNavComponent,
    EnglishProficiencyComponent,
    DashboardComponent,
    StudentValidationComponent,
    ParentsValidationComponent,
    ImportantInformationComponent,
    StudentsParentsValidationComponent,
    ParentGuardianDetailsComponent,
    SchoolProgramPlacementComponent,
    AccommodationWelfareComponent,
    SpecialCircumstancesComponent,
    DefaultCorrespondentComponent,
    SupportingDocumentsComponent,
    SummaryComponent,
    ParentGuardianDetailsEditComponent,
    AddressComponent,
    PersonDetailsComponent,
    PhoneNumberComponent,
    ApplicationDetailsComponent,
    ApplicationPaymentComponent,
    AgentDashboardComponent,
    AgentStudentRegistrationComponent,
    AgentStudentRegistrationGdprComponent,

    AustralianAddressPipe,
    OverseasAddressPipe,
    UtcDatePipe,
    DescriptionFromLookupPipe,

    ClickStopPropagation,
    ParentLegalcustodianEditComponent,
    ParentLegalcustodianInfoComponent,
    ParentLegalcustodianDetailsComponent,
    ParentAddressComponent,
    ApplicationAgentDetailsComponent,
    SummaryPrintComponent
  ],
  providers: [
    AuthGuard, 
    AuthResolverService,
    MatNativeDateModule,
    {provide: DateAdapter, useClass: PickDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS}]
})
export class ApplicationModule { }
